import { Empty, Popover, Spin } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading } from 'store/actionReducers/LoadingStore';
import { changeInputSearchStock } from 'store/actionReducers/StocksAnalysisStore';
import './TableListCompany.scss'

export default function TableListCompany(props: any) {
  const data = props?.data
  const dispatch = useDispatch();
  const LoadingStore = useSelector((state: any) => state?.LoadingStore)

  const handleScroll = (e: any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      if (props.LoadMoreData) {
        props.LoadMoreData()
      }
    }
  }

  const handleChangeInputSearch = (value: any) => {
    dispatch(changeInputSearchStock({ value: value, loading: true }))
  }

  return (
    <>
      <div className="qftwmkuwec">
        <div className="qjeafiuebr">
          <div className="nlrnnisgps">Mã</div>
          <div className="nlrnnisgps yxmudgiwtr">Tăng trưởng</div>
          <div className="nlrnnisgps yxmudgiwtr">Giá trị</div>
          <div className="nlrnnisgps yxmudgiwtr">Động lượng</div>
          <div className="nlrnnisgps yxmudgiwtr">DSC đánh giá</div>
        </div>
        <Spin spinning={LoadingStore?.loading.indexOf('companySame') > -1}>
          <div className="zwgsohsfyd" onScroll={(event) => handleScroll(event)}>
            {
              data && data.length > 0 ? data.map((item: any, key: number) => {

                return (
                  <div className="oaeyzaloen" key={key} onClick={() => handleChangeInputSearch(item?.ticker)}>
                    <div className="nlrnnisgps">
                      <Popover placement="bottom" title={''} content={item?.organname + ' - ' + item?.exchange} trigger="hover">
                        {item?.ticker}
                      </Popover>
                    </div>
                    <div className="nlrnnisgps yxmudgiwtr">
                      {item?.growth_ranking === 'A' ? <span className='daTwdEUShJ'>{item?.growth_ranking}</span> : null}
                      {item?.growth_ranking === 'B' ? <span className='FDNYwmKRZP'>{item?.growth_ranking}</span> : null}
                      {item?.growth_ranking === 'C' ? <span className='oLgzjLorHZ'>{item?.growth_ranking}</span> : null}
                      {item?.growth_ranking === 'D' ? <span className='WFsheDoiIY'>{item?.growth_ranking}</span> : null}
                    </div>
                    <div className="nlrnnisgps yxmudgiwtr">
                      {item?.value_ranking === 'A' ? <span className='daTwdEUShJ'>{item?.value_ranking}</span> : null}
                      {item?.value_ranking === 'B' ? <span className='FDNYwmKRZP'>{item?.value_ranking}</span> : null}
                      {item?.value_ranking === 'C' ? <span className='oLgzjLorHZ'>{item?.value_ranking}</span> : null}
                      {item?.value_ranking === 'D' ? <span className='WFsheDoiIY'>{item?.value_ranking}</span> : null}
                    </div>
                    <div className="nlrnnisgps yxmudgiwtr">
                      {item?.momentum_ranking === 'A' ? <span className='daTwdEUShJ'>{item?.momentum_ranking}</span> : null}
                      {item?.momentum_ranking === 'B' ? <span className='FDNYwmKRZP'>{item?.momentum_ranking}</span> : null}
                      {item?.momentum_ranking === 'C' ? <span className='oLgzjLorHZ'>{item?.momentum_ranking}</span> : null}
                      {item?.momentum_ranking === 'D' ? <span className='WFsheDoiIY'>{item?.momentum_ranking}</span> : null}
                    </div>
                    <div className="nlrnnisgps yxmudgiwtr">
                      {item?.dsc_rating_ranking === 'A' ? <span className='daTwdEUShJ'>{item?.dsc_rating_ranking}</span> : null}
                      {item?.dsc_rating_ranking === 'B' ? <span className='FDNYwmKRZP'>{item?.dsc_rating_ranking}</span> : null}
                      {item?.dsc_rating_ranking === 'C' ? <span className='oLgzjLorHZ'>{item?.dsc_rating_ranking}</span> : null}
                      {item?.dsc_rating_ranking === 'D' ? <span className='WFsheDoiIY'>{item?.dsc_rating_ranking}</span> : null}
                    </div>
                  </div>
                )
              }) : <div className='iivkrkghdy'>
                <Empty
                  image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                  imageStyle={{
                    height: 60,
                  }}
                  description={
                    <span className='wlisdivjnt'>
                      Dữ liệu đang cập nhật
                    </span>
                  } />
              </div>
            }
          </div>
        </Spin>
      </div>
    </>
  )
}